<template>
    <div class="ion-page">
        <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
            </ion-buttons>
            <ion-title>Manage Reservations</ion-title>
        </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <CPOReservations />
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
// @ is an alias to /src
import CPOReservations from "@/components/corporate/CPOReservations.vue";
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from "@ionic/vue";

export default defineComponent ({
    name: 'cporeservations',
    components: {
        CPOReservations, IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar
    },
    data() {
        return {

        }
    },
})
</script>